import { useState } from "react";

export const useCustomModal = (
  defaultTitle: string,
  defaultButtonTitle: string,
) => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState(defaultTitle);
  const [buttonTitle, setButtonTitle] = useState(defaultButtonTitle);

  const openModal = (newTitle: string, newButtonTitle: string) => {
    setIsOpen(true);
    setTitle(newTitle);
    setButtonTitle(newButtonTitle);
  };

  const closeModal = () => setIsOpen(false);

  return { isOpen, title, buttonTitle, openModal, closeModal };
};
